import { api } from "./api";
import { eventKey, normalizeDashboardEvent, readDashboardStorage } from "./dashboardGadgets";
import { flushClassroomDeletions, schoolCalendarForChild, waitForClassroomSync } from "./classroomEventSync";

export function attendanceByDate(records) {
    const map = {};
    const priority = {};
    for (const record of records) {
        const start = record.date || record.date_start;
        const end = record.date_end || start;
        if (!start || !end) continue;
        const first = Date.parse(`${start}T12:00:00Z`);
        const last = Date.parse(`${end}T12:00:00Z`);
        for (let current = first, count = 0; current <= last && count < 3660; current += 86400000, count += 1) {
            const date = new Date(current).toISOString().slice(0, 10);
            const rank = `${record.date ? "1" : "0"}:${record.updated_at || record.created_at || ""}`;
            if (!priority[date] || rank > priority[date]) {
                priority[date] = rank;
                map[date] = { ...record, date };
            }
        }
    }
    return map;
}

export async function syncReportSources(children) {
    await waitForClassroomSync();
    const stored = readDashboardStorage("shadowGroveEvents", []);
    const events = Array.isArray(stored) ? stored : [];
    const results = await Promise.allSettled(children.map(async (child) => {
        const id = String(child.child_id);
        await flushClassroomDeletions([id]);
        const response = await api.get(`/children/${encodeURIComponent(id)}/classroom-dashboard`);
        const subjects = response.data.subjects || [];
        const known = new Set(subjects.map((subject) => String(subject.subject_id ?? subject.id)));
        const configs = Object.fromEntries(subjects.map((subject) => [String(subject.subject_id ?? subject.id), readDashboardStorage(`shadowGroveGrading_${subject.subject_id ?? subject.id}`, null)]).filter(([, config]) => config));
        const payload = { events: events.filter((event) => String(event.child_id) === id && known.has(String(event.subject_id))).slice(0, 1000),
            grading_settings: configs, time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone };
        if (localStorage.getItem("shadowGroveSchoolCalendar")) payload.calendar = schoolCalendarForChild(readDashboardStorage("shadowGroveSchoolCalendar", {}), id);
        await api.post(`/children/${encodeURIComponent(id)}/classroom-dashboard/sync`, payload);
        const attendance = readDashboardStorage(`shadowGroveAttendance_${id}`, []);
        if (Array.isArray(attendance) && attendance.length) await api.post(`/children/${encodeURIComponent(id)}/attendance/sync`, { records: attendance });
    }));
    return results.every((result) => result.status === "fulfilled");
}

export function publishReviewedAssignment(event) {
    const stored = readDashboardStorage("shadowGroveEvents", []);
    const next = [...(Array.isArray(stored) ? stored : []).filter((item) => eventKey(item) !== eventKey(event)), normalizeDashboardEvent(event)];
    localStorage.setItem("shadowGroveEvents", JSON.stringify(next));
    window.dispatchEvent(new CustomEvent("shadowGroveEventsUpdated", { detail: next }));
}
